import { Controller } from "@hotwired/stimulus"

// Toggles the expanded "See All Modules" section on the dashboard.
export default class extends Controller {
  static targets = ["expanded", "toggleText", "toggleIcon"]

  toggle() {
    const isHidden = this.expandedTarget.classList.contains("hidden")

    if (isHidden) {
      this.expandedTarget.classList.remove("hidden")
      this.toggleTextTarget.textContent = "Show Less"
      this.toggleIconTarget.style.transform = "rotate(180deg)"
    } else {
      this.expandedTarget.classList.add("hidden")
      this.toggleTextTarget.textContent = "See All Modules"
      this.toggleIconTarget.style.transform = ""
    }
  }
}
